/**
 * Имена городов и районов на языке интерфейса.
 *
 * Сам справочник (id, названия ru/uz, карта районов) живёт в `@app/shared/geo` — он один
 * на бэкенд и фронт. Здесь только выбор нужного языка, как `industryName` в `domain/catalog`.
 * Неизвестный id возвращает `null`, а не подставляет что-то: фильтр мог прийти из старой
 * ссылки, и «город БЕРЛИН» лучше не показать вовсе, чем нарисовать пустой строкой.
 */

import { UZ_CITIES, districtsOf, type Lang } from '@app/shared';

export function cityName(id: string, lang: Lang): string | null {
  const city = UZ_CITIES.find((c) => c.id === id);
  if (!city) return null;
  return lang === 'ru' ? city.nameRu : city.nameUz;
}

export function districtName(cityId: string, districtId: string, lang: Lang): string | null {
  const district = districtsOf(cityId).find((d) => d.id === districtId);
  if (!district) return null;
  return lang === 'ru' ? district.nameRu : district.nameUz;
}

/**
 * Единая подпись для пилюли и строки профиля: «Ташкент · Чиланзар», «Навои» или `null`,
 * если город не выбран. Район без известного города опускается — показывать «· Чиланзар»
 * без города бессмысленно.
 */
export function cityDistrictLabel(
  city: string | null,
  district: string | null,
  lang: Lang,
): string | null {
  if (city === null) return null;
  const c = cityName(city, lang);
  if (c === null) return null;
  const d = district !== null ? districtName(city, district, lang) : null;
  return d !== null ? `${c} · ${d}` : c;
}
